// AXIOS
axios.defaults.baseURL = 'https://data.f-togakuren.com'
axios.defaults.headers.common['Authorization'] = 'Bearer 6ddb45da8358001a50a0355aa42049'

// DAY.JS
dayjs.locale('ja')


// queryパラメータを処理する
const query = {}
{
  const queryStr = window.location.search.substring(1)
  queryStr.split('&').forEach((params) => {
    const elms = params.split('=')
    const key = decodeURIComponent(elms[0])
    const value = decodeURIComponent(elms[1])
    query[key] = value
  })
}

// 警告・退場の定義
const CARD_TYPES = {
  yellow: [
    ['C1', '反スポーツ的行為'],
    ['C2', 'ラフプレー'],
    ['C3', '異議'],
    ['C4', '繰り返しの違反'],
    ['C5', '遅延行為'],
    ['C6', '距離不足'],
    ['C7', '無許可入'],
    ['C8', '無許可去'],
  ],
  red: [
    ['S1', '著しく不正なプレー'],
    ['S2', '乱暴な行為'],
    ['S3', 'つば吐き'],
    ['S4', '得点機会阻止(手)'],
    ['S5', '得点機会阻止(他)'],
    ['S6', '侮辱'],
    ['CS', '警告2回'],
  ]
}

// 得点ランキングの表示数
const RANKING_LIMIT = 1000

// 過去の試合結果のページID
const PAST_GAMES_PAGE_ID = 496

// 高速スクロール
function smoothScrollTo(targetY, duration = 200) {
  const startY = window.pageYOffset
  const diff = targetY - startY
  let startTime = null

  function step(timestamp) {
    if (!startTime) startTime = timestamp
    const time = timestamp - startTime
    const progress = Math.min(time / duration, 1)

    // easeOutCubic（キビキビした動き）
    const ease = 1 - Math.pow(1 - progress, 3)

    window.scrollTo(0, startY + diff * ease)

    if (time < duration) {
      requestAnimationFrame(step)
    }
  }

  requestAnimationFrame(step)
}